<template>
  <div class="amapBox">
    <baidu-map class="bm-view" :scroll-wheel-zoom="true" @ready="handler">
    </baidu-map>
    <div class="toolbar">
      <div class="th">查询面板</div>
      <div class="td">
          <el-descriptions border size="mini" :columns="3" :labelStyle="{width:'80px'}">
            <el-descriptions-item :span="3">
              <template slot="label">单位等级:</template>
                <el-select v-model="query.this_level" size="mini">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item) in query.levels" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">单位类型:</template>
                <el-select v-model="query.this_type" size="mini">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item) in query.types" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">申报方式:</template>
                  <el-select v-model="query.checktype" size="mini">
                    <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item) in query.checktypes" :key="item.FID" :label="item.FVALUE"
                            :value="item.FID"></el-option>
                    </el-select>
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">申报状态:</template>
                  <el-select v-model="query.adv_state" size="mini">
                    <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item) in query.adv_states" :key="item.FID" :label="item.FVALUE"
                            :value="item.FID"></el-option>
                    </el-select>
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">评级得分:</template>
              <el-input-number size="mini" v-model="query.minfs"></el-input-number>至<el-input-number size="mini" v-model="query.maxfs"></el-input-number>
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">坐标偏移</template>
              <el-switch
                v-model="query.drift"
                active-color="#13ce66"
                inactive-color="#ccc">
              </el-switch>
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">模糊查找:</template>
              <el-input v-model="query.key" size="mini"></el-input>
            </el-descriptions-item>
          </el-descriptions>
          <el-button size="small" type="danger" style="width:80%;" @click="getlist()">查找</el-button>
      </div>
    </div>
  </div>
</template>
<script>
      // window._AMapSecurityConfig = {
      //     securityJsCode:window.configdata.maptoken
      // }
// import { mapState } from "vuex";
//import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import { stat } from "fs";
export default {
  //components:{BaiduMap},
  name: "AMap",
  data() {
    return {
      MAP:null,
      BMAP:null,
      mapCenter: {lng:0, lat:0}, //地图中心
      zoom:3,
      query:{
        this_type:'',
        types:[],
        this_level:'',
        levels:[],
        checktype:'',
        checktypes:[],
        adv_states:[],
        adv_state:'通过',
        minfs:0,
        maxfs:100,
        key:'',
        drift:false
      }
    };
  },
  created(){
    let that=this
    that.GETENUM('adv_check','checktype',false,function(res){
        that.query.checktypes = res
    })
    that.GETENUM('adv_check','adv_state',false,function(res){
        that.query.adv_states = res
    })
    that.GetDict('单位等级',function(res){
        that.query.levels = res.data
    })
    that.GetDict('单位类型',function(res){
        that.query.types = res.data
    })
    this.GetTasks()
  },
  mounted() {
    //this.getGeoCoordMap();
    //this.getlist()
  },
  methods: {
    handler ({BMap, map}) {
      let that = this
      this.BMAP = BMap
      this.MAP = map;      
      that.getlist();
    },
    initmap(callback){
      let that = this
      this.mapCenter= this.SYS.mapcenter;//{lng:109.740239, lat:28.319517}
      //this.zoom = 10
      let cityName =  this.SYS.areaname// this.CU.cu.orgname;

      this.MAP.centerAndZoom(cityName, 10);
      //map.addControl(new BMap.OverviewMapControl());              //添加缩略地图控件
      //map.enableScrollWheelZoom();
      that.MAP.addControl(new that.BMAP.NavigationControl({ type: BMAP_NAVIGATION_CONTROL_LARGE, anchor: BMAP_ANCHOR_TOP_LEFT, offset: new that.BMAP.Size(40, 250) }));
      let bdary = new that.BMAP.Boundary();
      bdary.get(cityName, function (rs) {         //获取行政区域
        that.MAP.clearOverlays();                    //清除地图覆盖物
        //东西经南北纬的范围
        let EN_JW = "180, 90;";         //东北角
        let NW_JW = "-180,  90;";       //西北角
        let WS_JW = "-180, -90;";       //西南角
        let SE_JW = "180, -90;";        //东南角
        //添加环形遮罩层（岳阳市数据有问题，暂时不显示）
        if(that.SYS.areaCover == false){
          let ply1 = new that.BMAP.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, { strokeColor: "none", fillColor: "rgb(246,246,246)", fillOpacity: 1, strokeOpacity: 0.5 }); //建立多边形覆盖物
          that.MAP.addOverlay(ply1);
        }
        //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
        let ply = new that.BMAP.Polygon(rs.boundaries[0], { strokeWeight: 2, strokeColor: "#00f", fillColor: "" });
        that.MAP.addOverlay(ply);
        callback()
        
      });
    },
    addmarker(item){
      let that = this
      let ico = '/static/p4.png';
      var lev = item.this_level;
      if (lev == "市级")
        lev = "市（州）级"
      switch (lev) {
        case "县（市区）级":
          ico = '/static/p1.png'
          break;
        case "市（州）级":
          ico = '/static/p2.png'
          break;
        case "省级":
          ico = '/static/p3.png'
          break;
        case "国家级":
          ico = '/static/p4.png'
          break;
      }
      if (item.adv_gps) {
        var myIcon = new that.BMAP.Icon(ico, new that.BMAP.Size(50, 65), {   
            // 指定定位位置。  
            // 当标注显示在地图上时，其所指向的地理位置距离图标左上   
            // 角各偏移10像素和25像素。您可以看到在本例中该位置即是  
            // 图标中央下端的尖角位置。   
            anchor: new that.BMAP.Size(10, 25),   
        });
            // 创建标注对象并添加到地图  
        var opts = {
            width : 300,     // 信息窗口宽度
            height: 150,     // 信息窗口高度
            title : "<b>"+item.adv_name+"</b>" , // 信息窗口标题
            message: item.adv_tel
        }
        let lnglat = item.adv_gps.split(',');
        let lng = lnglat[0]*1;
        let lat = lnglat[1]*1;
        if(that.query.drift){
          lng = lng+0.0065
          lat = lat +0.0060
        }
        let point = new BMap.Point(lng,lat)
        var iw = new that.BMAP.InfoWindow("地址："+item.adv_address+"<br/>电话："+item.adv_tel, opts);
        var marker = new that.BMAP.Marker(point, {icon: myIcon});

        marker.addEventListener("click",function(e){
          that.MAP.openInfoWindow(iw,point);
        });
        that.MAP.addOverlay(marker); 
      }     
    },
    GetTasks() {
      const that = this
      let pars = {
        wheres: [{ field: 'a.tounit', sym: '=', val: this.CU.cu.orgid, oper: 'and' },
        { field: 'a.readed', sym: '=', val: '未读', oper: 'and' }],
        PageSize: 50,
        CurrentPage: 1, orders: [{ field: 'a.t_date', asc: 'asc' }]
      }
      that.PostData('Flow/GetTasks', pars, res => {
        that.tasks = res.data.data
        that.tasksrt = res.data.rowTotal
        if (that.tasksrt > 0) {
          that.notif = that.$notify({
            title: '消息提醒',
            type: 'success',
            offset: 60,
            duration: 8500,
            dangerouslyUseHTMLString: true,
            message: '您有待读消息<strong>' + that.tasksrt + '</strong>条,点击查看详情。',
            onClick: function () {
              that.notif.close();
              that.$router.replace("/main/tasksquery");
            }
          });
        }
      }, err => {
        that.$alert(err, { title: "错误" });
      })
    },
    getlist(){
      let that = this
      this.initmap(function () {
        let wherestring = [
          { field: 'adv_id', sym: 'like', val: that.CU.cu.orgid + '%', oper: 'and' },
          { field: 'adv_fs', sym: '>=', val: that.query.minfs, oper: 'and' },
          { field: 'adv_fs', sym: '<=', val: that.query.maxfs, oper: 'and' },
          {field: 'c_yy',sym: '=',val: that.CU.cu.yy,oper: 'and'},
        ]
        if (that.query.adv_state)
          wherestring.push({ field: 'adv_state', sym: '=', val: that.query.adv_state, oper: 'and' })
        if (that.query.checktype)
          wherestring.push({ field: 'checktype', sym: '=', val: that.query.checktype, oper: 'and' })
        if (that.query.this_type)
          wherestring.push({ field: 'this_type', sym: '=', val: that.query.this_type, oper: 'and' })
        if (that.query.this_level)
          wherestring.push({ field: 'this_level', sym: '=', val: that.query.this_level, oper: 'and' })
        if (that.query.key)
          wherestring.push({ field: 'adv_name', sym: 'like', val: '%' + that.query.key + '%', oper: 'and' })
        let pars = { objname: "adv_check", wheres: wherestring, PageSize: 500, CurrentPage: 1 }
        that.PostData("Common/GETLIST", pars, function (res) {
          for (let item of res.data.data) {
            that.addmarker(item)
          }
        }, function (err) {
          that.$alert(err, { title: "错误" });
        });
      })
    },
  },
};
</script>
<style scoped lang="less">
.bm-view {
  width: 100%;
  height: 100%;
}

.amapBox {
  width: 100%;
  height: 100%;
}
.toolbar {
  font-size: 15px;
  z-index: 3;
  border: 1px solid #E43D33;
  border-bottom-left-radius:10px;
  border-bottom-right-radius:10px;
  background-color: #fff;
  width: 280px;
  position: fixed;
  top: 110px;
  right: 5px;

  .th {
    background-color: #E43D33;
    font-size: 15px;
    font-weight: bold;
    padding: 5px 10px;
    color: white;
  }

  .td {
    padding: 10px;
    text-align:center;
  }
}
.amap-marker-label {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: none;
  -webkit-box-shadow: 1px 2px 4px #cccccc;
  -moz-box-shadow: 1px 2px 4px #cccccc;
  box-shadow: 1px 2px 4px #cccccc;
}
</style>